// https://nuxtjs.org/api/pages-key/
// https://nuxtjs.org/api/components-nuxt
// NOTE: ignore hash and query per default, only take path into account
export default ({ path }) => [path].filter(Boolean).join('?');
